import { APIConstants } from '../../constants/api';
import { apiService } from '..';
import {
  GetUserProfileInterface,
  GetUserProfileAPIResponseInterface,
} from './types';
import { ParentApplicationId } from '../../constants/global';

class UserService {
  public static getUserProfile: GetUserProfileInterface = () => {
    return apiService
      .get<GetUserProfileAPIResponseInterface>({
        path: APIConstants.USER.GET_USER_PROFILE,
        params: {
          parentApplicationId: ParentApplicationId ?? '',
        },
      })
      .then((response) => {
        const { data } = response;
        return data;
      })
      .catch((error) => {
        throw error;
      });
  };
}

export default UserService;
